<template>
  <div>
    <b-loading
        v-model="isLoading"
        :can-cancel="false"
        :is-full-page="true"
    ></b-loading>
    <stages-modal ref="stagesModal" @onUpdateStages="onUpdateStages" />
    <div style="background: #eeeeee;">
      <transition name="fade" mode="out-in" v-if="selectedPackagingProject === null">
        <search-box-packaging ref="searchBoxPackaging" style="margin-top: 150px"
                              @onToggleSelectedProject="onToggleSelectedProject"></search-box-packaging>
      </transition>
      <g-map-data-packaging @onMapClicked="onMapClicked" @onMapLoaded="onMapLoaded"></g-map-data-packaging>

      <div v-if="selectedPackagingProject" class="pb-6">
        <div>
          <div class="is-flex has-background-white title-box p-2">
            <div class="is-size-4 ml-5 mr-2 pt-1 pb-1 has-text-weight-bold">{{ selectedPackagingProject.project.name }}
            </div>
            <b-tooltip class="ml-1 mt-auto mb-auto mr-2" label="Refresh project" :delay="1000" type="is-dark"
                       position="is-top">
              <b-button aria-label="refresh"
                        @click="onRefreshClicked">
                <b-icon icon="refresh"></b-icon>
              </b-button>
            </b-tooltip>
            <b-tooltip class="ml-auto mt-auto mb-auto mr-2" label="Close project" :delay="1000" type="is-dark"
                       position="is-top">
              <b-button class="card-header-icon" aria-label="more options"
                        @click="closeProjectOverview">
                <b-icon icon="close"></b-icon>
              </b-button>
            </b-tooltip>
          </div>
          <div class="is-flex is-flex-direction-column p-5" style="padding-bottom: 200px !important;">
            <div class="is-size-6 mb-3 mt-2">Sites and Devices</div>
            <packaging-data-card
                v-for="st in selectedPackagingProject.sites" :key="st._id" :site-data="st"
                :progress="progress"
                @onShowError="onShowErrors"
                @onPrepareClick="onPrepareClick"
                @onDownloadClick="onDownloadClick"
                @onRefreshActive="onRefreshActive"
                @onExtractImages="onExtractImagesClick"
                @onUpdateStageNames="onUpdateStageNames"
                @onSubmitData="onSubmitDataClicked"
                @onSubmitResponse="onSubmitResponseClicked"
            ></packaging-data-card>
          </div>
        </div>
      </div>
    </div>
    <download-file ref="downloadVideos" @onDownloadClicked="onDownloadClick" class="ml-2">Download snippets
    </download-file>
    <b-modal v-model="showDownloadDialog" has-modal-card :can-close="true">
      <div class="modal-card" style="width: 500px">
        <header class="modal-card-head">
          <p class="modal-card-title">Download Files</p>
          <button class="delete" aria-label="close" @click="showDownloadDialog = false"></button>
        </header>
        <section class="modal-card-body">
          <p>Which files do you want to download?</p>
        </section>
        <footer class="modal-card-foot is-flex is-justify-content-space-between">
          <b-button @click="showDownloadDialog = false">Cancel</b-button>
          <div>
            <b-button type="is-info" outlined @click="onDownloadConfirm(true)">Only CSV</b-button>
            <b-button type="is-info" @click="onDownloadConfirm(false)">All Files</b-button>
          </div>
        </footer>
      </div>
    </b-modal>
    <b-modal v-model="showSubmitCommentDialog" has-modal-card :can-close="true">
      <div class="modal-card" style="width: 500px">
        <header class="modal-card-head">
          <p class="modal-card-title">Submit Data</p>
          <button class="delete" aria-label="close" @click="showSubmitCommentDialog = false"></button>
        </header>
        <section class="modal-card-body">
          <b-field label="Comment (optional)">
            <b-input v-model="submitComment" type="textarea" placeholder="Enter a comment..."></b-input>
          </b-field>
        </section>
        <footer class="modal-card-foot is-flex is-justify-content-space-between">
          <b-button @click="showSubmitCommentDialog = false">Cancel</b-button>
          <b-button type="is-info" @click="onSubmitCommentConfirm">Continue</b-button>
        </footer>
      </div>
    </b-modal>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import SearchBoxPackaging
  from "@/modules/data-packaging-module/components/search-box-packaging/search-box-packaging.vue";
import GMapDataPackaging
  from "@/modules/data-packaging-module/components/g-map-data-packaging/g-map-data-packaging.vue";
import PackagingDataCard from "@/modules/data-packaging-module/components/packaging-data-card/packaging-data-card.vue";
import DownloadFile from "@/components/download-file/download-file.vue";
import {extractS3Files} from "@/utils/utils";
import StagesModal from "@/modules/data-packaging-module/components/stages-modal/stages-modal.vue";

export default {
  name: "data-packaging-page",
  components: {
    StagesModal,
    DownloadFile,
    PackagingDataCard,
    GMapDataPackaging,
    SearchBoxPackaging
  },
  data() {
    return {
      isLoading: false,
      progress: 0,
      timer: null,
      count: 0,
      refreshSeconds:30,
      refreshingData: false,
      refreshActive: false,
      showDownloadDialog: false,
      downloadSiteData: null,
      showSubmitCommentDialog: false,
      submitComment: '',
      submitSiteId: null
    }
  },
  mounted() {
    console.log('On Mounted')
    this.setSelectedPackagingDevice(null)


    this.timer = setInterval(async () => {
      if (!this.refreshingData) {
        this.count++
        this.progress = this.count / this.refreshSeconds * 100
        if (this.count === this.refreshSeconds) {
          this.count = 0
          this.progress = this.count / this.refreshSeconds * 100
          if (this.refreshActive) {
            this.refreshActive = false
            await this.setSelectedPackagingProject(this.selectedPackagingProject.project)
          }
          //this.refreshData()
        }
      }
    }, 1000)
  },
  beforeDestroy() {
    clearInterval(this.timer)
    this.timer = null
    this.count = 0
  },
  methods: {
    ...mapActions({
      setSelectedPackagingProject: 'dataPackagingModule/setSelectedPackagingProject',
      setSelectedPackagingDevice: 'dataPackagingModule/setSelectedPackagingDevice',
      preparePackagingData: 'dataPackagingModule/preparePackagingData',
      extractDtpImagesForSite: 'dataPackagingModule/extractImagesForSite',
      updateSiteStages: 'dataPackagingModule/updateSiteStages',
      submitData: 'dataPackagingModule/submitData',
      getBulkUrls: 'dataPackagingModule/getBulkFilesUrls'
    }),
    onRefreshActive() {
      console.log('On refresh active')
      this.refreshActive = true
    },
    async onPrepareClick(site) {
      console.log('On prepare click: ', site)
      if (site._id) {
        this.isLoading = true
        let response = await this.preparePackagingData(site._id)

        await this.sleep(2000)
        await this.onRefreshClicked()

        if (response instanceof Error) {
          this.showSnackBar(`ERROR: ${response.message}`, 'is-danger')
        } else {
          this.showToast('Packaging Data successfully prepared', 'is-success')
        }
        this.isLoading = false
      } else {
        this.showToast('Missing site id', 'is-danger')
      }
    },
    async sleep(ms) {
      return new Promise(resolve => setTimeout(resolve, ms))
    },
    onDownloadClick(siteData) {
      this.downloadSiteData = siteData
      this.showDownloadDialog = true
    },
    onDownloadConfirm(csvOnly) {
      this.showDownloadDialog = false
      this.isLoading = true
      setTimeout(() => {
        this.performDownload(this.downloadSiteData, csvOnly)
        console.log('Test on next tick')
      }, 500)
    },
    async performDownload(siteData, csvOnly) {
      console.log('On download click: ', siteData, 'csvOnly:', csvOnly)
      if (siteData && siteData.devices.length > 0) {
        const seenKeys = new Set();
        let extractedFiles = []
        siteData.devices.forEach(device => {
          if (device && device.packagedDataset && device.packagedDataset.attachements) {
            let files = extractS3Files(device.packagedDataset.attachements, device.packagedDataset.siteDetails.name)
            console.log('Files: ', files)
            //Skip duplicates
            files.forEach(file => {
              const uniqueIdentifier = `${file.s3BucketName}|${file.s3Key}|${file.path}`;
              if (!seenKeys.has(uniqueIdentifier)) {
                seenKeys.add(uniqueIdentifier);
                extractedFiles.push(file);
              }
            });
          }
        })
        if (csvOnly) {
          extractedFiles = extractedFiles.filter(file => file.path.endsWith('.csv'))
        }
        console.log('ExtractedFiles: ', extractedFiles)
        if (extractedFiles.length > 0) {
          this.isLoading = true
          let response = await this.getBulkUrls(extractedFiles)
          console.log('Get urls response: ', response)
          this.isLoading = false
          if (response instanceof Error) {
            this.showSnackBar(`ERROR: ${response.message}`, 'is-danger')
          } else {
            await this.$refs.downloadVideos.downloadFiles(response, siteData.name)
          }
        } else {
          this.isLoading = false
          this.showSnackBar('Extracted files not available', 'is-danger')
        }
      }
    },
    async onExtractImagesClick(siteId) {
      const payload = {
        siteId: siteId,
        projectId: this.selectedPackagingProject.project._id
      }
      console.log('On extract images for site id:', payload)
      this.isLoading = true
      let response = await this.extractDtpImagesForSite(payload)
      if (response instanceof Error) {
        this.showSnackBar(`ERROR: ${response.message}`, 'is-danger')
      } else {
        await this.sleep(2000)
        await this.onRefreshClicked()
        this.showToast('Extracting images successfully started', 'is-success')
      }
      this.isLoading = false
    },
    onUpdateStageNames(siteData){
      console.log('On update stage names:', siteData)
      this.$refs.stagesModal.show(true, siteData, 'Update Selected Stages')
    },
    async onUpdateStages(data) {
      console.log('On update stages:', data)
      this.isLoading = true
      let response = await this.updateSiteStages(data.payload)
      if (response instanceof Error) {
        this.showSnackBar(`ERROR: ${response.message}`, 'is-danger')
      } else {
        this.$refs.stagesModal.show(false, null, 'Update stages')
        this.showToast('Stages successfully updated', 'is-success')
        await this.onRefreshClicked()
      }
      this.isLoading = false


    },
    onSubmitDataClicked(siteId) {
      this.submitSiteId = siteId
      this.submitComment = ''
      this.showSubmitCommentDialog = true
    },
    onSubmitCommentConfirm() {
      this.showSubmitCommentDialog = false
      this.$nextTick(() => {
        this.performSubmitData(this.submitSiteId, this.submitComment)
      })
    },
    async performSubmitData(siteId, comment) {
      const payload = {
        siteId: siteId,
        type: 'submit_data',
        comment: comment || ''
      }
      console.log('On submit data for site id:', payload)

      this.isLoading = true
      let response = await this.submitData(payload)
      if (response instanceof Error) {
        await this.sleep(1000)
        await this.onRefreshClicked()
        this.showSnackBar(`ERROR: ${response.message}`, 'is-danger')
      } else {
        await this.sleep(1000)
        await this.onRefreshClicked()
        if(response && response.status === 'OK'){
          this.showToast(`Site ${response.siteName} ${response.siteStatus}`, 'is-success')
        }else{
          await this.sleep(30000)
          await this.onRefreshClicked()
          this.$buefy.dialog.confirm({
            title: 'Submission Status Info',
            message: 'The submission process is taking longer than usual. Please verify that the site status has been updated to <b>Submitted</b> and check the <b>Submitted at</b> timestamp to confirm it matches the time when you initiated the process.',
            confirmText: 'OK',
            cancelText: 'Refresh Again',
            type: 'is-warning',
            hasIcon: true,
            icon: 'alert-circle',
            onCancel: () => this.onRefreshClicked()
          })
        }

      }
      this.isLoading = false

    },
    async onSubmitResponseClicked(siteId) {
      const payload = {
        siteId: siteId,
        type: 'submit_response'
      }
      console.log('On submit response for site id:', payload)
      this.isLoading = true
      let response = await this.submitData(payload)
      if (response instanceof Error) {
        await this.sleep(1000)
        await this.onRefreshClicked()
        this.showSnackBar(response.message, 'is-danger')
      } else {
        await this.sleep(1000)
        await this.onRefreshClicked()
        if(response && response.status === 'OK'){
          this.showToast(`Site ${response.siteName} ${response.siteStatus}`, 'is-success')
        }else{
          //this.showToast('Bad response', 'is-danger')
          this.showSnackBar('Error: Bad response', 'is-danger')
        }
      }
      this.isLoading = false
    },
    onShowErrors(errors) {
      console.log('On show errors', errors)
      //this.$refs.errorsModal.show(true, errors)
    },
    async onRefreshClicked() {
      this.refreshActive = false
      this.isLoading = true
      await this.setSelectedPackagingProject(this.selectedPackagingProject.project)
      this.isLoading = false
    },
    async onToggleSelectedProject(project) {
      console.log('Selected project: toggle', project)
      if (project === null) {
        await this.setSelectedPackagingProject(null)
      } else {
        this.isLoading = true
        await this.setSelectedPackagingProject(project)
        this.isLoading = false
      }
    },
    onMapClicked() {
      console.log('On map clicked')
      if (this.$refs.searchBoxQa) {
        this.$refs.searchBoxPackaging.onClickedOutside()
      }
      console.log('Selected Processing Project: ', this.selectedPackagingProject)
    },
    onMapLoaded() {
      console.log('On map loaded')
    },
    closeProjectOverview() {
      this.setSelectedPackagingProject(null)
    },
    showToast(message, type) {
      this.$buefy.toast.open({
        message: message,
        duration: 3000,
        type: type
      })
    },
    showSnackBar(message, type) {
      this.$buefy.snackbar.open({
        message: message,
        type: type,
        position: 'is-top',
        actionText: 'Ok',
        indefinite: true,
        /*        onAction: () => {
                  this.$buefy.toast.open({
                    message: 'Action pressed',
                    queue: false
                  })
                }*/
      })
    },
  },
  computed: {
    ...mapGetters({
      selectedPackagingProject: 'dataPackagingModule/getSelectedPackagingProject',
      selectedDevice: 'dataPackagingModule/getSelectedProcessingDevice'
    })
  }
}
</script>

<style scoped>
.title-box {
  background-color: hsl(0deg, 0%, 100%);
  border-radius: 0;
  box-shadow: 0 0.125em 0.5em -0.125em rgb(10 10 10 / 10%), 0 0px 0 1px rgb(10 10 10 / 2%);
  color: hsl(0deg, 0%, 29%);
  display: block;
  padding: 1.25rem;
}
</style>